<template>
    <div class="Statement">
        <swiper
            class="swiper"
            :class="{ 'swiper-whole': isSpecial }"
            :options="swiperOption"
            v-if="swiperArr"
            ref="mySwiper"
        >
            <swiper-slide
                v-for="(item, index) in swiperArr"
                :key="index"
                :data-strId="item.strId"
            >
                <router-link
                    target="_blank"
                    :to="{
                        path: '/detail',
                        query: {
                            strWebSiteId: $route.query.strWebSiteId,
                            strId: item.strId,
                        },
                    }"
                >
                    <div
                        class="swiper-item"
                        :style="{
                            background:
                                index == 0
                                    ? 'url(' +
                                      require('../../assets/images/statementbg1.jpg') +
                                      ') no-repeat center center'
                                    : index == 1
                                    ? 'url(' +
                                      require('../../assets/images/statementbg2.jpg') +
                                      ') no-repeat center center'
                                    : index == 2
                                    ? 'url(' +
                                      require('../../assets/images/statementbg3.png') +
                                      ') no-repeat center center'
                                    : index == 3
                                    ? 'url(' +
                                      require('../../assets/images/statementbg4.jpg') +
                                      ') no-repeat center center'
                                    : index == 4
                                    ? 'url(' +
                                      require('../../assets/images/statementbg5.jpg') +
                                      ') no-repeat center center'
                                    : '',
                        }"
                    >
                        <div class="info-wrap">
                            <h3 :data-strId="item.strId">
                                {{ item.strMasTitle }}
                            </h3>
                            <div class="text-wrap">
                                <p v-html="item.strText"></p>
                                <i>【详情】</i>
                            </div>
                        </div>
                        <img
                            :data-strId="item.strId"
                            :data-src="item.strPicPath"
                            :src="item.strPicPath"
                            alt=""
                        />
                    </div>
                </router-link>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.min.css';
export default {
    name: 'Statement',
    components: {
        Swiper,
        SwiperSlide,
    },
    props: {
        swiperArr: {
            type: Array,
            default: () => [],
        },
        isSpecial: {
            type: Boolean,
            default: false,
        },
    },
    computed: {},
    data() {
        return {
            swiperOption: {
                direction: 'vertical',
                // initialSlide: -2,
                slidesPerView: 2,
                spaceBetween: 10,
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false,
                },
            },
        };
    },
    watch: {},
    created() {},
    mounted() {},
    methods: {
        // 跳转详情
        detailHandle(strId) {
            let routeData = this.$router.resolve({
                path: '/detail',
                query: {
                    strWebSiteId: this.$route.query.strWebSiteId,
                    strId: strId,
                },
            });
            window.open(routeData.href, '_blank');
        },
    },
};
</script>

<style scoped lang="scss">
.Statement {
    width: 750px;
    .title {
        display: block;
        width: 100%;
        height: auto;
        margin: 0 auto;
    }
    .swiper {
        width: 100%;
        height: 350px;
        .swiper-slide {
            overflow: hidden;
            .swiper-item {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                .info-wrap {
                    flex: 1;
                    overflow: hidden;
                    box-sizing: border-box;
                    padding: 0 30px 0 85px;
                }
                h3 {
                    font-size: 22px;
                    color: #fff;
                    line-height: 30px;
                    font-weight: bold;
                    margin: 0 0 15px 0;
                    display: block;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    &:hover {
                        color: #1f5ac5;
                    }
                }
                .text-wrap {
                    p {
                        font-size: 18px;
                        line-height: 30px;
                        color: #fff;
                        margin: 0;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-inline-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    i {
                        font-style: normal;
                        font-size: 18px;
                        line-height: 30px;
                        color: #e3e53b;
                    }
                }
                img {
                    display: block;
                    width: 215px;
                    height: 165px;
                    margin: 0 auto;
                }
            }
            a {
                width: 100%;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
        .swiper-pagination {
            bottom: 3px;
            box-sizing: border-box;
            padding: 0 5px;
            text-align: center;
            z-index: 1;
            right: 0;
            left: 0;
            width: auto;
            /deep/ .swiper-pagination-bullet {
                width: 12px;
                height: 12px;
                background: #fff;
                display: inline-block;
                border-radius: 100%;
                position: relative;
                margin: 0 3px;
                opacity: 1;
                cursor: pointer;
                &:hover {
                    opacity: 1;
                }
                &.swiper-pagination-bullet-active {
                    background-image: linear-gradient(
                        to right,
                        #f71d1d,
                        #fba548
                    );
                    opacity: 1;
                }
            }
        }
    }
    .swiper-whole {
        width: 100%;
        height: 750px;
        .swiper-slide {
            display: block;
            p {
                font-size: 24px;
                height: 60px;
                line-height: 60px;
                padding: 0 20px;
            }
        }
        .swiper-pagination {
            bottom: 20px;
        }
    }
}
</style>
